// extracted by mini-css-extract-plugin
module.exports = {"headline":"Camp_headline__CamR8","image":"Camp_image__GyoFj","textWrapper":"Camp_textWrapper__yLQDm","wrapper":"Camp_wrapper__EC3W_"};